
    const data = {"name":"src/core/icons/shield-crown","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"m12 1 9 4v6c0 5.55-3.84 10.74-9 12-5.16-1.26-9-6.45-9-12V5l9-4m4 13H8v1.5c0 .27.19.46.47.5h6.96c.31 0 .52-.16.57-.41V14m1-6-2.67 2.67L12 8.34l-2.33 2.33L7 8l1 5h8l1-5Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            